/**
 * Theme Toggle Button
 * Shared component for theme switching across all portals
 */

import { Button } from '../../../components/ui/button'
import { cn } from '../../../lib/utils'
import { Sun, Moon } from '../../../icons'
import type { ThemeToggleProps } from './types'
import { BUTTON_SIZES, ICON_SIZES } from './constants'

// ============================================================================
// Helper Functions
// ============================================================================

function getButtonSize(isMobile?: boolean): string {
  return isMobile ? BUTTON_SIZES.MOBILE : BUTTON_SIZES.DESKTOP
}

// ============================================================================
// Component
// ============================================================================

export function ThemeToggle({ theme, onToggle, isMobile = false }: ThemeToggleProps) {
  const isDark = theme === 'dark'
  const Icon = isDark ? Sun : Moon
  const iconColor = isDark ? 'text-amber-400' : 'text-slate-600'

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onToggle}
      className={cn(
        'rounded-xl hover:bg-secondary transition-all',
        getButtonSize(isMobile)
      )}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <Icon className={cn(ICON_SIZES.DEFAULT, iconColor)} />
    </Button>
  )
}
